import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  openReportDateControls as onOpenReportDateControls,
  closeReportDateControls as onCloseReportDateControls
} from './../../actions/reportDateControlsActions'

const mapStateToProps = (state) => ({
  isReportDateControlsOpen: get(state, ['reportDateControls', 'isDateControlsOpen'], true)
})

const mapDispatchToProps = {
  onOpenReportDateControls,
  onCloseReportDateControls
}

const withReportDateControls = Component => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withReportDateControls }